import VueJwtDecode from "vue-jwt-decode";

const storeData = {
    state: {
        token: null,
        tokenExpiration: null,
        userId: null,
        userName: null,
        userRoles: null,
        isActive: false,
        apiUrl: "https://api.agenda.serialconsult.com",
        //apiUrl: "http://10.10.10.90:8000",
        statuses: 0,
        // Must be declared for Vue 2 reactivity. Missing these breaks
        // isTherapistSelected after setTherapist (calendar never mounts /
        // no appointment API calls). Production VPS build already had them.
        therapistId: null,
        dbId: null,
    },
    actions: {
        async login(context, payload) {
            return context.dispatch('auth', {
                ...payload
            });
        },
        async auth(context, payload) {
            const rut = payload.rut.split('-');
            const response = await fetch(context.getters.apiUrl + "/api/login_check", {
                method: 'POST',
                headers: new Headers({'content-type': 'application/json'}),
                body: JSON.stringify({
                    username: rut[0],
                    password: payload.email
                })
            });
            const responseData = await response.json();

            if (response.ok) {
                context.dispatch('manageToken', {
                    token: responseData.token,
                    refresh_token: responseData.refresh_token
                });
            } else if (response.status === 401) {
                //console.log(responseData);
                throw new Error(responseData.message || 'Failed to authenticate.');
            }
        },
        async register(context, payload) {
            const rut = payload.rut.split('-');
            const response = await fetch(context.getters.apiUrl + "/api/v1/patient/new", {
                method: 'POST',
                headers: new Headers({'content-type': 'application/json'}),
                body: JSON.stringify({
                    rut: rut[0],
                    dv: rut[1],
                    email: payload.email,
                    firstName: payload.firstName,
                    fatherLastName: payload.fatherLastName,
                    motherLastName: payload.motherLastName,
                    address: payload.address,
                    phoneNumbers: payload.phoneNumbers,
                    birthDate: payload.birthDate
                })
            });
            const responseData = await response.json();

            if (response.ok) {
                //console.log(responseData);
            } else if (response.status === 400) {
                //console.log(responseData);
                //throw new Error(responseData.message || 'Failed to authenticate.');
            }
        },
        async tryLogin(context) {
            //console.log('tryLogin');
            const token = localStorage.getItem('token');
            if (token) {
                const decodedToken = VueJwtDecode.decode(token);
                const tokenExpiration = decodedToken.exp;
                const dbId = decodedToken.dbId;
                const userId = decodedToken.rut;
                const userRoles = decodedToken.roles;
                const isActive = decodedToken.isActive;
                const userName = decodeURIComponent(escape(decodedToken.userFullName));
                const expiresIn = (+tokenExpiration - (Math.round(new Date().getTime() / 1000))) * 1000;
                context.commit('setUser', {
                    token,
                    userId,
                    userRoles,
                    isActive,
                    userName,
                    dbId
                });
                if (expiresIn < 40000) {
                    await context.dispatch('refreshToken');
                }
            } else {
                await context.dispatch('logout');
            }
        },
        async refreshToken(context) {
            const refreshToken = localStorage.getItem('refresh_token');
            if (refreshToken) {
                const response = await fetch(context.getters.apiUrl + "/api/token/refresh", {
                    method: 'POST',
                    headers: new Headers({'content-type': 'application/json'}),
                    body: JSON.stringify({
                        refresh_token: refreshToken
                    })
                });
                const responseData = await response.json();
                if (response.ok) {
                    await context.dispatch('manageToken', {
                        token: responseData.token,
                        refresh_token: responseData.refresh_token
                    });
                } else if (response.status === 401) {
                    //console.info('refresh token expired');
                    await context.dispatch('logout');
                    // TODO: Mostrar un popup con formulario de login para que no pierda sesión
                }
            }
        },
        manageToken(context, payload) {
            //console.log('manageToken');
            const decodedToken = VueJwtDecode.decode(payload.token);
            const userId = decodedToken.rut;
            const userRoles = decodedToken.roles;
            const dbId = decodedToken.dbId;
            const isActive = decodedToken.isActive;
            const userName = decodedToken.userFullName;

            localStorage.setItem('token', payload.token);
            localStorage.setItem('refresh_token', payload.refresh_token);

            context.commit('setUser', {
                token: payload.token,
                userId,
                userRoles,
                isActive,
                userName,
                dbId,
            });
        },
        logout(context) {
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');

            context.commit('setUser', {
                token: null,
                userId: null,
                userRoles: null,
                isActive: false,
                userName: null,
                therapistId: null,
                dbId: null,
                statuses: 0,
            });
        },
    },
    getters: {
        userId: (state) => {
            return state.userId;
        },
        userName: (state) => {
            return state.userName;
        },
        userRoles: (state) => {
            return state.userRoles;
        },
        token: (state) => {
            return state.token;
        },
        isAuthenticated: (state) => {
            return !!state.token;
        },
        isActive: (state) => {
            return !!state.isActive;
        },
        apiUrl: (state) => {
            return state.apiUrl;
        },
        statuses: (state) => {
            return state.statuses;
        },
        therapistId: (state) => {
            return state.therapistId;
        },
        dbId: (state) => {
            return state.dbId;
        },
        isTherapistSelected: (state) => {
            return state.therapistId != null;
        },
        readonly: (state) => {
            return !!state.userRoles.includes("ROLE_READ_ONLY");
        },
    },
    mutations: {
        setUser(state, payload) {
            state.token = payload.token;
            state.userId = payload.userId;
            state.userRoles = payload.userRoles;
            state.isActive = payload.isActive;
            state.userName = payload.userName;
            state.statuses = payload.statuses;
            state.dbId = payload.dbId;
            if (state.userRoles && state.userRoles.includes("ROLE_THERAPIST")) {
                state.therapistId = payload.dbId;
            } else if (state.userRoles && state.userRoles.includes("ROLE_PATIENT")) {
                state.therapistId = payload.therapistId;
            }
            state.readonly = (state.userRoles && state.userRoles.includes("ROLE_READ_ONLY"));
        },
        setStatuses(state, payload) {
            state.statuses = payload.statuses;
        },
        setTherapist(state, payload) {
            state.therapistId = payload.therapistId;
        }
    }
};

export default storeData;
